import React from 'react';

const features = [
  {
    text: "Mais de ",
    boldText: "12.000 tipos de exames",
    additionalText: " disponíveis"
  },
  {
    text: "Atendimento com ",
    boldText: "médicos do Einstein",
    additionalText: ""
  },
  {
    text: "Rede com ",
    boldText: "+12.000 credenciados",
    additionalText: " (Dasa, Fleury, FEME e outros)"
  },
  {
    text: "Aprovado por milhares de brasileiros em mais de ",
    boldText: "300 cidades",
    additionalText: ""
  },
  {
    text: "Capilaridade Nacional e ",
    boldText: "sem carência",
    additionalText: ""
  },
  {
    text: "Sem juros e ",
    boldText: "sem multa contratual",
    additionalText: ""
  }
];

export const FeatureList = () => {
  return (
    <div className="features-container">
      <ul >
        {features.map((feature, index) => (
          <li
            key={index}
            className="mb-3 text-light"
            style={{ fontSize: '16px' }}
          >
            {feature.text}
            <strong>{feature.boldText}</strong>
            {feature.additionalText}
          </li>
        ))}
      </ul>
    </div>
  );
};
